import React, { createContext, useContext, ReactNode } from 'react'
import { useElectricSync } from '../hooks/useElectricSync'

interface ElectricSyncContextValue {
  isInitialized: boolean
  isSyncing: boolean
  error: Error | null
  lastSyncAt: Date | null
}

const ElectricSyncContext = createContext<ElectricSyncContextValue | null>(null)

interface ElectricSyncProviderProps {
  children: ReactNode
  userId: string | null
  enabled?: boolean
}

/**
 * Electric Sync 提供者组件
 * 在应用根组件包裹，提供同步状态上下文
 */
export function ElectricSyncProvider({ children, userId, enabled = true }: ElectricSyncProviderProps) {
  const syncState = useElectricSync({ userId, enabled })

  return (
    <ElectricSyncContext.Provider value={syncState}>
      {children}
    </ElectricSyncContext.Provider>
  )
}

/**
 * 使用 Electric Sync 上下文
 */
export function useElectricSyncContext(): ElectricSyncContextValue {
  const context = useContext(ElectricSyncContext)
  if (!context) {
    throw new Error('useElectricSyncContext 必须在 ElectricSyncProvider 内使用')
  }
  return context
}
